import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import { ConsolidatedForecastsListView } from '@futrli/views/views/forecasts/ConsolidatedForecastsListView/ConsolidatedForecastsListView';
import { ForecastsView } from '@futrli/views/views/forecasts/ForecastsView/ForecastsView';
import { ListingPageHeader } from '@futrli/ui-components/components/listing-page/listing-page-header/listing-page-header';
import { matchConsolidationDetailRoutePath } from '@futrli/shared-services/organisations/utils/routes/consolidations';
import { useApiView } from '@futrli/views/hooks/useApiView';

import { PerformanceComparison } from '../components/performance-comparison/performance-comparison';

export const PerformanceComparisonContainer = () => {
  const { workspaceId = '', organisationId = '' } = useParams();
  const isConsolidation = !!matchConsolidationDetailRoutePath(window.location.pathname);

  const ViewClass = isConsolidation ? ConsolidatedForecastsListView : ForecastsView;
  const view = useApiView(
    useMemo(() => new ViewClass(workspaceId, organisationId), [ViewClass, workspaceId, organisationId])
  );
  const { forecasts } = view.state;

  return (
    <>
      <ListingPageHeader
        variant="tab-header"
        title={
          <FormattedMessage
            id="predict.forecasting.dashboard.performance_comparison"
            defaultMessage="Performance comparison"
          />
        }
        helpUrl="https://support.futrli.com/en/articles/14301322-performance-comparison"
        mb={2}
      />
      <PerformanceComparison forecasts={forecasts} />
    </>
  );
};
